const ArrowBoxDown = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M54.2 2H9.8A7.8 7.8 0 0 0 2 9.8v44.4A7.8 7.8 0 0 0 9.8 62h44.4a7.8 7.8 0 0 0 7.8-7.8V9.8A7.8 7.8 0 0 0 54.2 2zM41.4 39.4L32 48.8l-1.4-1.4-8-8a2 2 0 1 1 2.8-2.8l4.6 4.6V20a2 2 0 0 1 4 0v21.2l4.6-4.6a2 2 0 0 1 2.8 2.8z"
      fill={color}
    ></path>
  </svg>
);

export default ArrowBoxDown;
